module.exports = {"id":"183833","name":"Ima Faneva Andriatsima","rating":"72","photo":"./data/images/photos/1/183833.png","club":{"name":"Havre AC","logo":"./data/images/clubs/HavreAC.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ImaFanevaAndriatsima0.json
// module id = 1802
// module chunks = 0